import React, { useState, useCallback, useEffect } from "react";
import "./App.less";
import { Menu as AntMenu, Spin, ConfigProvider, Layout } from "antd";
import { BricksCanvas } from "./fragments/BricksCanvas";
import Menu from "./fragments/Menu";
import { useAppSelector, useAppDispatch } from "./store/hooks";
import { selectBricksLoading, fetchBricks } from "./store/slices/bricksSlice";
import { selectDrawing } from "./store/slices/wallManagerSlice";
import Logo from './assets/Ploegsteert-RGB-lang.png'

const App: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(true);
  const dispatch = useAppDispatch();
  const bricksLoading = useAppSelector(selectBricksLoading);
  const wallManagerDrawing = useAppSelector(selectDrawing);

  useEffect(() => {
    dispatch(fetchBricks());
  }, [dispatch]);

  const handleMenuClick = useCallback(() => {
    setMenuOpen((oldValue) => !oldValue)
  }, [setMenuOpen]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: '#ffffff',
            headerHeight: 48,
            headerPadding: 12,
          }
        },
        token: {
          colorPrimary: '#d23a2a',
        },
      }}
    >
      <Layout className="App">
      <Layout.Header style={{ display: 'flex', alignItems: 'center' }}>
          <img src={Logo} height={32}/>
        <AntMenu
          mode="horizontal"
          selectedKeys={[menuOpen ? 'menu' : '']}
          items={[
            {
              key: 'menu',
              label: <div style={{ fontWeight: 'bold'}}>Menu</div>,
              onClick: handleMenuClick
            }
          ]}
          style={{ flex: 1, minWidth: 0 }}
        >
          
        </AntMenu>
        </Layout.Header>
        {(wallManagerDrawing || bricksLoading) && (
          <div className="spinner">
            <Spin />
          </div>
        )}
        {menuOpen && <Menu />}
        <BricksCanvas />
      </Layout>
    </ConfigProvider>
  );
};

export default App;
